import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OvertimeSum  {
    _originalTypeClassName = "zERP.BO.OvertimeSum";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OvertimeSum.translate = translateService;
}
this.Key = null;
this.HoursSum = null;
this.OvertimeSumKey = null;
this._key = this.OvertimeSumKey = 0; 
}

static translate: TranslateService;
_key: any;
Key:any;
HoursSum:any;
private _OvertimeSumKey:any;
get OvertimeSumKey(): any {
    return this._OvertimeSumKey;
  }
set OvertimeSumKey(value: any) {
    this._OvertimeSumKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OvertimeSumKey == null || $this.OvertimeSumKey == 0;
            }


}